import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-DAt3we1k.js";
import { a as n, i as r, l as i, n as a, o, r as s, s as c, t as l, u } from "../dist-BBT9ugBv.js";
import * as d from "react";
import { jsx as f } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-tabs@1.1.21_@types+react-dom@19.2.3_@types+react@19.2.17__@types+react@_7d6ba3f0011b74834facac4517a51da9/node_modules/@radix-ui/react-tabs/dist/index.mjs
var p = Object.defineProperty, m = (e, t) => p(e, "name", {
	value: t,
	configurable: !0
}), h = "Tabs", [g, _] = u(h, [r]), v = r(), [y, b] = g(h), x = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ m(function(e, t) {
	let { __scopeTabs: r, value: a, onValueChange: s, defaultValue: l, orientation: u = "horizontal", dir: d, activationMode: p = "automatic", ...m } = e, g = n(d), [_, v] = o({
		prop: a,
		onChange: s,
		defaultProp: l ?? "",
		caller: h
	});
	return /* @__PURE__ */ f(y, {
		scope: r,
		baseId: c(),
		value: _,
		onValueChange: v,
		orientation: u,
		dir: g,
		activationMode: p,
		children: /* @__PURE__ */ f(i.div, {
			dir: g,
			"data-orientation": u,
			...m,
			ref: t
		})
	});
}, "Tabs")), S = "TabsList", C = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ m(function(e, t) {
	let { __scopeTabs: n, loop: r = !0, ...a } = e, o = b(S, n);
	return /* @__PURE__ */ f(s, {
		asChild: !0,
		...v(n),
		orientation: o.orientation,
		dir: o.dir,
		loop: r,
		children: /* @__PURE__ */ f(i.div, {
			role: "tablist",
			"aria-orientation": o.orientation,
			...a,
			ref: t
		})
	});
}, "TabsList")), w = "TabsTrigger", T = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ m(function(e, n) {
	let { __scopeTabs: r, value: o, disabled: s = !1, ...c } = e, l = b(w, r), u = v(r), d = O(l.baseId, o), p = k(l.baseId, o), m = o === l.value;
	return /* @__PURE__ */ f(a, {
		asChild: !0,
		...u,
		focusable: !s,
		active: m,
		children: /* @__PURE__ */ f(i.button, {
			type: "button",
			role: "tab",
			"aria-selected": m,
			"aria-controls": p,
			"data-state": m ? "active" : "inactive",
			"data-disabled": s ? "" : void 0,
			disabled: s,
			id: d,
			...c,
			ref: n,
			onMouseDown: t(e.onMouseDown, (e) => {
				!s && e.button === 0 && e.ctrlKey === !1 ? l.onValueChange(o) : e.preventDefault();
			}),
			onKeyDown: t(e.onKeyDown, (e) => {
				s || e.target !== e.currentTarget || [" ", "Enter"].includes(e.key) && l.onValueChange(o);
			}),
			onFocus: t(e.onFocus, () => {
				let e = l.activationMode !== "manual";
				!m && !s && e && l.onValueChange(o);
			})
		})
	});
}, "TabsTrigger")), E = "TabsContent", D = /* @__PURE__ */ d.forwardRef(/* @__PURE__ */ m(function(e, t) {
	let { __scopeTabs: n, value: r, forceMount: a, children: o, ...s } = e, c = b(E, n), u = O(c.baseId, r), p = k(c.baseId, r), m = r === c.value, h = d.useRef(m);
	return d.useEffect(() => {
		let e = requestAnimationFrame(() => h.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), /* @__PURE__ */ f(l, {
		present: a || m,
		children: ({ present: n }) => /* @__PURE__ */ f(i.div, {
			"data-state": m ? "active" : "inactive",
			"data-orientation": c.orientation,
			role: "tabpanel",
			"aria-labelledby": u,
			hidden: !n,
			id: p,
			tabIndex: 0,
			...s,
			ref: t,
			style: {
				...e.style,
				animationDuration: h.current ? "0s" : void 0
			},
			children: n && o
		})
	});
}, "TabsContent"));
function O(e, t) {
	return `${e}-trigger-${t}`;
}
m(O, "makeTriggerId");
function k(e, t) {
	return `${e}-content-${t}`;
}
m(k, "makeContentId");
var A = x, j = C, M = T, N = D, P = A, F = d.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ f(j, {
	ref: r,
	className: e("inline-flex h-9 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground", t),
	...n
}));
F.displayName = j.displayName;
var I = d.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ f(M, {
	ref: r,
	className: e("inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow", t),
	...n
}));
I.displayName = M.displayName;
var L = d.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ f(N, {
	ref: r,
	className: e("ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", t),
	...n
}));
L.displayName = N.displayName;
//#endregion
export { P as Tabs, L as TabsContent, F as TabsList, I as TabsTrigger };

//# sourceMappingURL=tabs.js.map